import React from "react";
import "../styles/subpages.css";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import { useTranslation } from "react-i18next";

const Privacy = () => {
  const { t } = useTranslation("global");
  return (
    <>
      <Navbar />
      <div className="subpage">
        <h1>{t("privacy.heading")}</h1>
        <p>{t("privacy.effectiveDate")}</p>
        <p>{t("privacy.companyName")}</p>
        <p>{t("privacy.website")}</p>
        <p>{t("privacy.contactEmail")}</p>

        <h2>{t("privacy.introHeading")}</h2>
        <p>
          {t("privacy.introContent")}
        </p>

        <h2>{t("privacy.dataCollectHeading")}</h2>
        <p>{t("privacy.dataCollectIntro")}</p>
        <h3>{t("privacy.directInfoHeading")}</h3>
        <ul>
          <li>{t("privacy.fullName")}</li>
          <li>{t("privacy.email")}</li>
          <li>{t("privacy.phone")}</li>
          <li>{t("privacy.company")}</li>
          <li>{t("privacy.project")}</li>
          <li>{t("privacy.documents")}</li>
        </ul>
        <h3>{t("privacy.autoInfoHeading")}</h3>
        <ul>
          <li>{t("privacy.ipAddress")}</li>
          <li>{t("privacy.deviceInfo")}</li>
          <li>{t("privacy.pageVisits")}</li>
          <li>{t("privacy.referralUrl")}</li>
          <li>{t("privacy.cookiePrefs")}</li>
        </ul>
        <h3>{t("privacy.thirdPartyInfoHeading")}</h3>
        <ul>
          <li>{t("privacy.analytics")}</li>
          <li>{t("privacy.adPlatforms")}</li>
          <li>{t("privacy.crmTools")}</li>
        </ul>

        <h2>{t("privacy.dataUseHeading")}</h2>
        <p>{t("privacy.dataUseIntro")}</p>
        <ul>
          <li>{t("privacy.respondInquiries")}</li>
          <li>
            {t("privacy.sendUpdates")}
          </li>
          <li>{t("privacy.improveWebsite")}</li>
          <li>{t("privacy.fulfillObligations")}</li>
          <li>{t("privacy.manageOperations")}</li>
          <li>{t("privacy.legalCompliance")}</li>
        </ul>

        <h2>{t("privacy.legalBasisHeading")}</h2>
        <p>{t("privacy.legalBasisIntro")}</p>
        <ul>
          <li>{t("privacy.consent")}</li>
          <li>
            {t("privacy.contractual")}
          </li>
          <li>
            {t("privacy.legitimateInterests")}
          </li>
          <li>{t("privacy.legalObligation")}</li>
        </ul>

        <h2>{t("privacy.dataSharingHeading")}</h2>
        <p>
          {t("privacy.dataSharingIntro")}
        </p>
        <ul>
          <li>{t("privacy.webHosting")}</li>
          <li>{t("privacy.analyticsTools")}</li>
          <li>{t("privacy.crmPlatforms")}</li>
          <li>{t("privacy.emailPlatforms")}</li>
          <li>{t("privacy.cloudStorage")}</li>
          <li>{t("privacy.marketingTools")}</li>
        </ul>
        <p>
          {t("privacy.thirdPartyMeasures")}
        </p>

        <h2>{t("privacy.intlTransfersHeading")}</h2>
        <p>
          {t("privacy.intlTransfersContent")}
        </p>

        <h2>{t("privacy.retentionHeading")}</h2>
        <p>
          {t("privacy.retentionIntro")}
        </p>
        <ul>
          <li>{t("privacy.contactFormRetention")}</li>
          <li>
            {t("privacy.clientDataRetention")}
          </li>
          <li>{t("privacy.marketingDataRetention")}</li>
        </ul>

        <h2>{t("privacy.rightsHeading")}</h2>
        <p>{t("privacy.rightsIntro")}</p>
        <ul>
          <li>{t("privacy.accessRight")}</li>
          <li>{t("privacy.correctionRight")}</li>
          <li>{t("privacy.objectRight")}</li>
          <li>{t("privacy.withdrawRight")}</li>
          <li>{t("privacy.portabilityRight")}</li>
        </ul>
        <p>{t("privacy.exerciseRights")}</p>

        <h2>{t("privacy.childrenHeading")}</h2>
        <p>
          {t("privacy.childrenContent")}
        </p>

        <h2>{t("privacy.cookiesHeading")}</h2>
        <p>
          {t("privacy.cookiesContent")}
        </p>

        <h2>{t("privacy.securityHeading")}</h2>
        <p>
          {t("privacy.securityIntro")}
        </p>
        <ul>
          <li>{t("privacy.sslEncryption")}</li>
          <li>{t("privacy.accessControl")}</li>
          <li>{t("privacy.dataHygiene")}</li>
          <li>{t("privacy.secureStorage")}</li>
        </ul>

        <h2>{t("privacy.changesHeading")}</h2>
        <p>
          {t("privacy.changesContent")}
        </p>

        <h2>{t("privacy.contactUsHeading")}</h2>
        <p>
          {t("privacy.contactUsIntro")}
        </p>
        <p>{t("privacy.companyNameFooter")}</p>
        <p>
          {t("privacy.companyAddress")}
        </p>
        <p>{t("privacy.companyEmail")}</p>
      </div>
      <Footer />
    </>
  );
};

export default Privacy;